export const messages = {
  labels: {
    startDate: {
      id: 'treatmentSummary.Groups.Chemotherapy.StartDate',
      defaultMessage: 'Start Date: ',
    },
    mostRecentTreatmentDate: {
      id: 'treatmentSummary.Groups.Chemotherapy.MostRecentTreatmentDate',
      defaultMessage: 'Most Recent Treatment Date: ',
    },
    endDate: {
      id: 'treatmentSummary.Groups.Chemotherapy.EndDate',
      defaultMessage: 'End Date: ',
    },
    dose: {
      id: 'treatmentSummary.Groups.Chemotherapy.Dose',
      defaultMessage: 'Cumulative Dose: ',
    },
    cyclesDelivered: {
      id: 'treatmentSummary.Groups.Chemotherapy.CyclesDelivered',
      defaultMessage: '# Cycles: ',
    },
    frequency: {
      id: 'treatmentSummary.Groups.Chemotherapy.Frequency',
      defaultMessage: 'Frequency: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.Chemotherapy.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.Chemotherapy.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.Chemotherapy.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.Chemotherapy.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    trialName: {
      id: 'treatmentSummary.Groups.Chemotherapy.TrialName',
      defaultMessage: 'Regimen: ',
    },
    dosageForm: {
      id: 'treatmentSummary.Groups.Chemotherapy.DosageForm',
      defaultMessage: 'Form: ',
    },
    drugCategory: {
      id: 'treatmentSummary.Groups.Chemotherapy.DrugCategory',
      defaultMessage: 'Drug Category: ',
    },
    route: {
      id: 'treatmentSummary.Groups.Chemotherapy.Route',
      defaultMessage: 'Route: ',
    },
    trialIndicator: {
      id: 'treatmentSummary.Groups.Chemotherapy.TrialIndicator',
      defaultMessage: 'Part of Trial?: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.Chemotherapy.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
